import React from 'react';
import {
  ChatBubbleLeftRightIcon,
  PhotoIcon,
  PaperAirplaneIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';

const AIInquirySection = ({
  aiInput,
  setAIInput,
  aiLoading,
  onSendMessage,
  onImageUpload,
  onPaste,
  imagePreviewUrls = [],
  onRemoveImage,
}) => {
  const hasImages = Array.isArray(imagePreviewUrls) && imagePreviewUrls.length > 0;
  const canSend = Boolean((aiInput || '').trim() || hasImages);

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <div className="px-4 py-3 flex items-center gap-2">
        <ChatBubbleLeftRightIcon className="h-4 w-4 text-green-700" aria-hidden />
        <h3 className="text-sm font-semibold text-gray-800">AI农事助手</h3>
      </div>

      <div className="px-4 pb-4 space-y-4">
        <div>
          <input
            value={aiInput}
            onChange={(e) => setAIInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && canSend && !aiLoading && onSendMessage()}
            onPaste={onPaste}
            placeholder="请输入您的问题，例如：水稻近期病虫害防治建议"
            className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-green-500/30 focus:border-green-500 placeholder-gray-500 transition-all"
            disabled={aiLoading}
          />
        </div>

        {hasImages && (
          <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
            <div className="mb-2 text-xs text-gray-600">
              已选择 {imagePreviewUrls.length} 张图片
            </div>
            <div className="flex flex-wrap gap-2">
              {imagePreviewUrls.map((url, index) => (
                <div
                  key={`${index}-${String(url).slice(0, 24)}`}
                  className="relative h-16 w-16 overflow-hidden rounded-md border border-gray-200 bg-white"
                >
                  <img src={url} alt={`预览${index + 1}`} className="h-full w-full object-cover" />
                  {typeof onRemoveImage === 'function' && (
                    <button
                      type="button"
                      onClick={() => onRemoveImage(index)}
                      disabled={aiLoading}
                      className="absolute right-0.5 top-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-gray-800 text-white hover:bg-black"
                      aria-label="移除图片"
                    >
                      <XMarkIcon className="h-3.5 w-3.5" />
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => document.getElementById('ai-image-upload')?.click()}
            disabled={aiLoading}
            className="flex items-center gap-1.5 px-3 py-2 text-sm text-gray-600 hover:text-green-700 transition-colors disabled:opacity-50"
          >
            <PhotoIcon className="h-4 w-4" aria-hidden />
            {hasImages ? `再选图片（${imagePreviewUrls.length}/5）` : '上传图片'}
          </button>

          <button
            type="button"
            onClick={onSendMessage}
            disabled={aiLoading || !canSend}
            className="flex items-center gap-1.5 px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-semibold hover:bg-green-700 transition-colors disabled:opacity-50"
          >
            {aiLoading ? (
              <div className="animate-spin h-3.5 w-3.5 border-2 border-white border-t-transparent rounded-full" />
            ) : (
              <PaperAirplaneIcon className="h-3.5 w-3.5" aria-hidden />
            )}
            开始问询
          </button>
        </div>

        <input
          id="ai-image-upload"
          type="file"
          multiple
          accept="image/*,.jpg,.jpeg,.png,.webp,.gif,.bmp"
          onChange={onImageUpload}
          className="hidden"
        />
      </div>
    </div>
  );
};

export default AIInquirySection;
